'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.daily_active_report', {
        template: '<daily-active-report></daily-active-report>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/active_report/daily/daily_active_report.routes.js